export const phrases = {
  postingToEbay:
    "Posting to eBay. You may navigate away while we process your listing. We'll let you know when the process is complete.",
  process: "Please wait while we process your request",
};
